import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, StripeCard } from "../../../components";
import StripePaymentElement from '../../../components/payment/StripePaymentElement';
import { apiClient } from "../../../actions/api";

const Page = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { user } = useSelector(state => state.user);

    const [paymentMethod, setPaymentMethod] = useState(null);
    const [notFound, setNotFound]           = useState(false);
    const [loading, setLoading]             = useState(true);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [errorMsg, setErrorMsg]           = useState('');
    const [showSetupForm, setShowSetupForm]         = useState(false);
    const [setupClientSecret, setSetupClientSecret] = useState(null);

    const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

    useEffect(() => {
        fetchPaymentMethod();
    }, []);

    function fetchPaymentMethod() {
        setLoading(true);
        apiClient().get('/stripe/payment-method', {
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
            .then((res) => {
                setLoading(false);
                if (res.data.success) {
                    setPaymentMethod(res.data.payment_method);
                    setNotFound(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response && err.response.status === 404) {
                    setNotFound(true);
                } else {
                    setErrorMsg(t('common.error_generic') || 'Une erreur est survenue.');
                }
            });
    }

    function handleDelete() {
        setDeleteLoading(true);
        setErrorMsg('');
        apiClient().post('/stripe/payment-method/delete', {}, {
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
            .then((res) => {
                setDeleteLoading(false);
                if (res.data.success) {
                    setPaymentMethod(null);
                    setNotFound(true);
                }
            })
            .catch(() => {
                setDeleteLoading(false);
                setErrorMsg(t('common.error_generic') || 'Une erreur est survenue.');
            });
    }

    function fetchNewSetupIntent() {
        apiClient().post('/get-mandat', {
            token: user.api_token,
            api_token: user.api_token,
            user_id: user?.user_id,
            force_new_setup: true
        }, { headers: { 'Authorization': `Bearer ${user.api_token}` } })
            .then(res => {
                if (res.data.stripe_client_secret) {
                    setSetupClientSecret(res.data.stripe_client_secret);
                    setShowSetupForm(true);
                }
            })
            .catch(() => {
                setErrorMsg(t('common.error_generic') || 'Une erreur est survenue.');
            });
    }

    return (
        <div className="mescommandes register abonnement bg778635">
            <Container>
                <Row>
                    <Col className="text-center mx-auto my-5" lg="3">
                        <Menu slug='moyens-de-paiement' />
                    </Col>

                    <Col className="text-center mx-auto my-5 menudashright">
                        <h3 className="mb-4">{t('payment.my_payment_methods')}</h3>

                        <div className="contentsection">

                            {loading && (
                                <p className="text-muted">{t('common.loading') || 'Chargement…'}</p>
                            )}

                            {errorMsg && (
                                <div className="alert alert-danger">{errorMsg}</div>
                            )}

                            {!loading && notFound && (
                                <div>
                                    <div className="alert alert-warning">
                                        {t('payment.no_payment_method') || 'Aucun moyen de paiement enregistré.'}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={() => history.push('/abonnement')}
                                    >
                                        {t('payment.add_payment_method') || 'Ajouter un moyen de paiement'}
                                    </button>
                                </div>
                            )}

                            {!loading && paymentMethod && (
                                <div style={{maxWidth: '480px', margin: '0 auto'}}>
                                    <div style={{display:'flex', justifyContent:'center'}}>
                                        <StripeCard {...paymentMethod} />
                                    </div>

                                    {showSetupForm && setupClientSecret ? (
                                        <div style={{marginTop: '20px'}}>
                                            <StripePaymentElement
                                                clientSecret={setupClientSecret}
                                                stripePublishableKey={stripePublishableKey}
                                                onSuccess={({ paymentMethodId, paymentMethodType }) => {
                                                    apiClient().post('/save-transaction', {
                                                        token:               user.api_token,
                                                        api_token:           user.api_token,
                                                        payment_method_id:   paymentMethodId,
                                                        payment_method_type: paymentMethodType,
                                                        tarif_id:            null,
                                                        formule_id:          null,
                                                        amount:              0,
                                                        currency:            'EUR',
                                                    }, { headers: { 'Authorization': `Bearer ${user.api_token}` } })
                                                    .then(() => {
                                                        setShowSetupForm(false);
                                                        setSetupClientSecret(null);
                                                        setTimeout(() => fetchPaymentMethod(), 300);
                                                    })
                                                    .catch(() => {
                                                        setShowSetupForm(false);
                                                        setSetupClientSecret(null);
                                                        setTimeout(() => fetchPaymentMethod(), 300);
                                                    })
                                                }}
                                                onError={() => {}}
                                            />
                                        </div>
                                    ) : (
                                        <div className="d-flex mt-3" style={{gap: '10px', justifyContent: 'center'}}>
                                            <button
                                                type="button"
                                                className="btn btn-outline-dark"
                                                style={{color: '#212529'}}
                                                onMouseEnter={e => { e.currentTarget.style.backgroundColor='#212529'; e.currentTarget.style.color='#fff'; }}
                                                onMouseLeave={e => { e.currentTarget.style.backgroundColor='transparent'; e.currentTarget.style.color='#212529'; }}
                                                onClick={fetchNewSetupIntent}
                                            >
                                                {t('common.update') || 'Modifier'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                style={{color: '#dc3545'}}
                                                onMouseEnter={e => { e.currentTarget.style.backgroundColor='#dc3545'; e.currentTarget.style.color='#fff'; }}
                                                onMouseLeave={e => { e.currentTarget.style.backgroundColor='transparent'; e.currentTarget.style.color='#dc3545'; }}
                                                onClick={handleDelete}
                                                disabled={deleteLoading}
                                            >
                                                {deleteLoading ? t('common.deleting') : t('common.remove')}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Page;
